import { differenceInCalendarDays } from 'date-fns'
import { toDate } from '@/features/shared/format'
import type { ProjectStatus } from './types'

export type ScheduleState = { state: 'left' | 'today' | 'late'; days: number }

/** Bitiş tarihine kalan/geçen gün; bitişsiz, tamamlanmış ya da arşivli projede null. */
export function scheduleOf(endDate: string, status: ProjectStatus, now = new Date()): ScheduleState | null {
  if (!endDate || status === 'completed' || status === 'archived') return null
  const end = toDate(endDate)
  if (!end) return null
  const days = differenceInCalendarDays(end, now)
  if (days > 0) return { state: 'left', days }
  if (days === 0) return { state: 'today', days: 0 }
  return { state: 'late', days: -days }
}
